module.exports = __webpack_public_path__ + "img/02_pre-cooling_(white).0d56bf3c.svg";